export enum RemoteConfigKeys {
  DISABLE_TICKET_ONLINE = 'disable_ticket_online',
  ENABLE_ANTIFRAUD = 'enable_antifraud',
  ENABLE_CELLPHONE_VALIDATION = 'enable_cellphone_validation',
  ENABLE_PIX_PAYMENT_METHOD = 'enable_pix_payment_method',
  DEFAULT_PAYMENT_METHOD_CUTOFF_DATE = 'default_payment_method_cutoff_date',
}
